import React from "react";

type Props = {
  children: React.ReactNode;
  title?: string;
};

type State = {
  error: Error | null;
};

/**
 * Prevents a single page crash from wiping the authenticated shell to a blank black screen.
 */
export class AppErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error("[AppErrorBoundary]", error, info.componentStack);
  }

  render(): React.ReactNode {
    if (!this.state.error) return this.props.children;

    return (
      <div className="app-shell-dash" style={{ padding: "2rem", maxWidth: 560 }}>
        <h1 className="app-shell-page-title">{this.props.title ?? "Something went wrong"}</h1>
        <p className="app-shell-lede">
          The page failed to load. Try refreshing, or go back to the calendar.
        </p>
        <p className="eventos-subtle" style={{ marginTop: "0.75rem", wordBreak: "break-word" }}>
          {this.state.error.message}
        </p>
        <div style={{ display: "flex", gap: "0.75rem", marginTop: "1.25rem" }}>
          <button
            type="button"
            className="eventos-primary-btn"
            onClick={() => {
              this.setState({ error: null });
              window.location.assign("/calendar");
            }}
          >
            Open calendar
          </button>
          <button
            type="button"
            className="eventos-nav-btn"
            onClick={() => {
              this.setState({ error: null });
              window.location.reload();
            }}
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
